<template>
  <div>
    <div class="avatar">
      <el-upload
        class="uploader"
        action="#"
        :show-file-list="false"
        :auto-upload="false"
        :on-change="upload"
      >
        <el-image
          class="upload_img"
          v-if="info.avatar"
          :src="info.avatar"
          fit="cover"
        ></el-image>
        <!-- <i v-else class="el-icon-plus"></i> -->
        <van-icon name="photograph" class="icon" />
      </el-upload>
      <div>点击更换头像</div>
    </div>
    <van-cell
      title="名字"
      :value="info.name ? info.name : '点击设置'"
      is-link
      @click="showEditName = true"
    />
    <van-cell
      title="抖音号"
      :value="info.douyinNo ? info.douyinNo : '点击设置'"
      is-link
      @click="showEditDouyinNo = true"
    />
    <van-cell
      title="简介"
      :value="info.desc ? info.desc : '点击设置'"
      is-link
      @click="showEditDesc = true"
    />
    <van-cell
      title="性别"
      :value="info.sex ? info.sex : '点击设置'"
      is-link
      @click="showEditSex = true"
    />
    <van-cell
      title="生日"
      :value="info.birthday ? info.birthday : '点击设置'"
      is-link
      @click="showEditBirthday = true"
    />
    <van-cell
      title="所在地"
      :value="info.city ? info.city : '点击设置'"
      is-link
      @click="showEditCity = true"
    />
    <van-cell
      title="学校"
      :value="info.school ? info.school : '点击设置'"
      is-link
      @click="showEditSchool = true"
    />
    <van-cell
      title="主页背景"
      value="更换背景图片"
      is-link
      @click="showEditBackgroundImage = true"
    />

    <van-button type="primary" block class="save-btn" @click="save"
      >保存</van-button
    >

    <van-popup
      v-model="showEditName"
      position="right"
      :style="{ width: '100%', height: '100%' }"
    >
      <van-nav-bar
        title="修改名字"
        right-text="保存"
        left-arrow
        @click-left="showEditName = false"
        @click-right="saveName"
      />
      <div style="margin: 0 20px">
        <div class="tips">我的名字</div>
        <van-field v-model="name" placeholder="记得填写名字哦" />
        <div class="tips">名字30天内可修改4次</div>
      </div>
    </van-popup>
    <van-popup
      v-model="showEditDouyinNo"
      position="right"
      :style="{ width: '100%', height: '100%' }"
    >
      <van-nav-bar
        title="修改抖音号"
        right-text="保存"
        left-arrow
        @click-left="showEditDouyinNo = false"
        @click-right="saveDouyinNo"
      />
      <div style="margin: 0 20px">
        <div class="tips">我的抖音号</div>
        <van-field v-model="douyinNo" placeholder="记得填写抖音号哦" />
        <div class="tips">
          最多16个字，只允许包含字母、数字、下划线和点，180天内仅能修改1次
        </div>
      </div>
    </van-popup>

    <van-popup
      v-model="showEditDesc"
      position="right"
      :style="{ width: '100%', height: '100%' }"
    >
      <van-nav-bar
        title="修改简介"
        right-text="完成"
        left-arrow
        @click-left="showEditDesc = false"
        @click-right="saveDesc"
      />
      <div style="margin: 0 20px">
        <div class="tips">个人简介</div>
        <van-field
          v-model="desc"
          placeholder="你可以填写兴趣爱好、心情愿望，有趣的介绍能让被关注的概率变高噢！"
          rows="5"
          autosize
          type="textarea"
        />
      </div>
    </van-popup>

    <van-popup v-model="showEditSex" :style="{ width: '80%' }">
      <van-cell title="男" is-link @click="changeSex('男')"></van-cell>
      <van-cell title="女" is-link @click="changeSex('女')"></van-cell>
      <van-cell title="不展示" is-link @click="changeSex('不展示')"></van-cell>
    </van-popup>

    <van-popup v-model="showEditBirthday" position="bottom">
      <van-datetime-picker
        v-model="birthday"
        type="date"
        title="选择年月日"
        cancel-button-text="不展示"
        :min-date="minDate"
        :max-date="now"
        @confirm="saveBirthday"
        @cancel="showEditBirthday = false"
      />
    </van-popup>

    <van-popup v-model="showEditCity" position="bottom">
      <van-picker
        show-toolbar
        title="选择所在地"
        :columns="cityData"
        @cancel="showEditCity = false"
        @confirm="saveCity"
      />
    </van-popup>

    <van-popup v-model="showEditSchool" position="bottom">
      <van-picker
        show-toolbar
        title="选择学校"
        :columns="['某小学', '某中学', '某大学']"
        @cancel="showEditSchool = false"
        @confirm="saveSchool"
      />
    </van-popup>

    <van-overlay
      class=""
      :show="showEditBackgroundImage"
      @click="showEditBackgroundImage = false"
    >
      <el-image
        :src="info.backgroundImage"
        class="background-image"
        @click.native.stop
        fit="cover"
      >
        <div
          slot="error"
          style="
            height: 100%;
            background-color: #f5f7fa;
            font-size: 50px;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          <i class="el-icon-picture-outline"></i>
        </div>
      </el-image>

      <el-upload
        @click.native.stop
        style="text-align: center; margin-top: 50%"
        action="#"
        :show-file-list="false"
        :auto-upload="false"
        :on-change="uploadBackgroundImage"
        accept="image/*"
      >
        <div class="background-image-btn">更换背景</div>
      </el-upload>
    </van-overlay>
  </div>
</template>

<script>
import "vant/lib/index.css";
import {
  Cell,
  Popup,
  Icon,
  NavBar,
  Field,
  DatetimePicker,
  Picker,
  Overlay,
  Button,
  Dialog,
} from "vant";
import upload from "@/utils/uploadMethod";
import moment from "moment";
import city from "@/utils/city";
import { submit } from "@/api/chapterMock";
const cityStr = JSON.stringify(city.cityArr);
const cityData = JSON.parse(cityStr.replace(/name/g, "text"));
export default {
  components: {
    [Cell.name]: Cell,
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    [NavBar.name]: NavBar,
    [Field.name]: Field,
    [DatetimePicker.name]: DatetimePicker,
    [Picker.name]: Picker,
    [Overlay.name]: Overlay,
    [Button.name]: Button,
  },
  data() {
    return {
      now: new Date(),
      minDate: new Date(1970, 0, 1),
      cityData,
      // info: {},
      showEditName: false,
      name: null,
      showEditDouyinNo: false,
      douyinNo: null,
      showEditDesc: false,
      desc: null,
      showEditSex: false,
      showEditBirthday: false,
      birthday: null,
      showEditCity: false,
      showEditSchool: false,
      showEditBackgroundImage: false,
    };
  },
  computed: {
    info() {
      return this.$store.state.simulation.douyinInfo;
    },
  },
  methods: {
    async upload(file) {
      const fileUrl = await upload(file);
      this.$set(this.info, "avatar", fileUrl);
    },

    saveName() {
      if (this.name) {
        this.$set(this.info, "name", this.name);
        this.showEditName = false;
      }
    },
    saveDouyinNo() {
      if (this.douyinNo) {
        this.$set(this.info, "douyinNo", this.douyinNo);
        this.showEditDouyinNo = false;
      }
    },
    saveDesc() {
      if (this.desc) {
        this.$set(this.info, "desc", this.desc);
        this.showEditDesc = false;
      }
    },
    changeSex(sex) {
      this.$set(this.info, "sex", sex);
      this.showEditSex = false;
    },
    saveBirthday(val) {
      this.$set(this.info, "birthday", moment(val).format("YYYY-MM-DD"));
      this.showEditBirthday = false;
    },
    saveCity(val) {
      this.$set(this.info, "city", val.join("·"));
      this.showEditCity = false;
    },
    saveSchool(val) {
      this.$set(this.info, "school", val);
      this.showEditSchool = false;
    },
    async uploadBackgroundImage(file) {
      const fileUrl = await upload(file);
      this.$set(this.info, "backgroundImage", fileUrl);
    },
    save() {
      Dialog.confirm({
        title: "提示",
        message: "确认提交内容？",
      }).then(() => {
        const classChapterId = localStorage.getItem("mockChapterId");
        submit({
          classChapterId,
          content: JSON.stringify(this.info),
        }).then((res) => {
          Dialog.alert({
            title: "提示",
            message: "提交完成",
          }).then(() => {
            this.$router.back()
            // window.close();
            // window.parent.close();
          });
        });
        // console.log(JSON.stringify(this.info));
      });
    },
  },
};
</script>

<style lang="less" scoped>
.avatar {
  width: 100%;
  text-align: center;
  font-weight: bold;
  margin-bottom: 30px;

  .uploader {
    display: inline-block;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-color: #999999;
    // border: 1px dashed #d9d9d9;
    cursor: pointer;
    position: relative;
    vertical-align: top;
    overflow: hidden;
    margin-bottom: 10px;

    &:hover {
      border-color: #409eff;
    }
    .icon {
      font-size: 28px;
      color: #ffffff;
      line-height: 80px;
    }

    .upload_img {
      width: 80px;
      height: 80px;
      display: block;
    }
  }
}

.tips {
  font-size: 12px;
  color: #333333;
}

.background-image {
  margin-top: 50%;
  width: 100%;
  height: 30%;
}

.background-image-btn {
  background-color: #333333;
  color: #ffffff;
  width: 260px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
}

.save-btn {
  margin: 0 auto;
  margin-top: 30px;
  width: 90%;
  background-color: #f83257;
  border-color: #f83257;
}
</style>